import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=46f01580&scoped=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&lang=js"
import style0 from "./ProfileInfo.vue?vue&type=style&index=0&id=46f01580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f01580",
  null
  
)

export default component.exports